import React, { createContext, ReactNode, useContext, useState } from 'react';
import { CreateScheduleDTO } from '../models/Scheduler/CreateScheduleDTO';

interface ScheduleContextType {
    scheduleDTO: CreateScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<CreateScheduleDTO>>;
    isCreateFormVisible: boolean;
    setIsCreateFormVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const ScheduleContext = createContext<ScheduleContextType | null>(null);

export const useSchedule = () => {
    const context = useContext(ScheduleContext);
    if (!context) {
        throw new Error("useSchedule deve ser usado dentro de um ScheduleProvider");
    }
    return context;
};

interface ScheduleProviderProps {
    children: ReactNode;
}

const initialScheduleDTO: CreateScheduleDTO = {
    assistanceId: null,
    assistanceName: null,
    clientErpId: null,
    clientName: null,
    equipmentErpId: null,
    equipmentCarPlateName: null,
    equipmentSerialNumberName: null,
    equipmentBrandName: null,
    equipmentModelName: null,
    equipmentSkuName: null,
    checkinStartDate: null,
    checkinEndDate: null,
    checkinNotes: null,
    checkinTechnicianId: null,
    executionStartDate: null,
    executionEndDate: null,
    executionNotes: null,
    executionTechnicianId: null,
    type: null
};

export const ScheduleProvider: React.FC<ScheduleProviderProps> = ({ children }) => {
    const [scheduleDTO, setScheduleDTO] = useState<CreateScheduleDTO>(initialScheduleDTO);
    const [isCreateFormVisible, setIsCreateFormVisible] = useState(false);

    return (
        <ScheduleContext.Provider value={{ scheduleDTO, setScheduleDTO, isCreateFormVisible, setIsCreateFormVisible }}>
            {children}
        </ScheduleContext.Provider>
    );
};